import styled, { css } from 'styled-components';
import { flexBoxCenter, layerA } from '../styles/commonStyles';
import System from './system/System';
import { useEffect, useState } from 'react';
import WeatherBox from '../commonComponentsMC/WeatherBox';
import TitleBar from './TitleBar';
import {
  getFaultsAlertsHandler,
  getWifiAlertStatusHandler,
} from '../../helpers/helpers';

const SpecificLocationReportStatus = ({
  specificLocations,
  specLocationKey,
  specLocationValue,
  specificLocationIdx,
  location,
  locationKey,
}) => {
  const specificLocationData = specLocationValue;

  const [filteredMachines, setFilteredMachines] = useState([]);
  const [totalMachines, setTotalMachines] = useState(0);
  const [faults, setFaults] = useState([]);
  const [systemEbp, setSystemEbp] = useState([]);
  const [systemGp, setSystemGp] = useState([]);
  const [isWeatherForecast, setIsWeatherForecast] = useState(false);

  useEffect(() => {
    const { filteredData, faultsState } =
      getFaultsAlertsHandler(specLocationValue);

    setFilteredMachines(filteredData);
    setFaults(faultsState);
    const total = filteredData.reduce((acc, [, systemData]) => {
      if (Array.isArray(systemData.machines)) {
        return acc + systemData.machines.length;
      } else if (Array.isArray(systemData)) {
        return acc + systemData.length;
      }
      return acc;
    }, 0);
    setTotalMachines(total);

    const essEbp = getWifiAlertStatusHandler(
      'essSwitches',
      'isEbp',
      specificLocationData,
      true,
      true,
    );

    const tgsEbp = getWifiAlertStatusHandler(
      'tgsSwitches',
      'isEbp',
      specificLocationData,
      true,
      true,
    );

    const tesEbp = getWifiAlertStatusHandler(
      'tesSwitches',
      'isEbp',
      specificLocationData,
      true,
      true,
    );

    const combinedEbp = [...essEbp, ...tgsEbp, ...tesEbp];

    setSystemEbp(combinedEbp);

    const essGp = getWifiAlertStatusHandler(
      'essSwitches',
      'isGp',
      specificLocationData,
      true,
      true,
    );

    const tgsGp = getWifiAlertStatusHandler(
      'tgsSwitches',
      'isGp',
      specificLocationData,
      true,
      true,
    );

    const tesGp = getWifiAlertStatusHandler(
      'tesSwitches',
      'isGp',
      specificLocationData,
      true,
      true,
    );

    const combinedGp = [...essGp, ...tgsGp, ...tesGp];

    setSystemGp(combinedGp);
  }, [specificLocationData]);

  return (
    <Wrapper>
      {isWeatherForecast && (
        <WeatherBoxWrapper>
          <WeatherBox
            handleCloseWeatherBox={setIsWeatherForecast}
            locationId={locationKey}
            specificLocationId={specLocationKey}
          />
        </WeatherBoxWrapper>
      )}
      <SpecificLocationWrapper zeroSW={filteredMachines.length === 0}>
        <TitleBarWrapper>
          <TitleBar
            location={location}
            handleCloseWeatherBox={setIsWeatherForecast}
            specificLocationKey={specLocationKey}
            machinesTotal={totalMachines}
          />
        </TitleBarWrapper>

        {filteredMachines?.map((el, idx) => {
          return (
            <SystemWrapper key={idx}>
              <System
                systemIndex={idx}
                switchMachines={el}
                isFault={faults.length > 0 && faults}
                systemEbp={systemEbp}
                systemGp={systemGp}
                locationId={locationKey}
                specificLocationId={specLocationKey}
              />
            </SystemWrapper>
          );
        })}
      </SpecificLocationWrapper>
    </Wrapper>
  );
};

export default SpecificLocationReportStatus;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const WeatherBoxWrapper = styled.div`
  position: absolute;
  z-index: 10;
`;

const SpecificLocationWrapper = styled.div`
  width: 1192px;
  height: auto;
  ${({ zeroSW }) =>
    zeroSW
      ? css`
          border-radius: 18px;
        `
      : css`
          border-radius: 18px 18px 37px 37px;
        `}

  ${layerA};
  ${flexBoxCenter};
  margin-top: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  flex-direction: column;
  gap: 8px;
`;

const TitleBarWrapper = styled.div`
  width: 1188px;
  height: 32px;
`;

const SystemWrapper = styled.div`
  width: 1188px;
  min-height: 71px;
`;
